import { render } from "./HeadquarterDialog.vue?vue&type=template&id=46c6692e&scoped=true"
import script from "./HeadquarterDialog.vue?vue&type=script&lang=js"
export * from "./HeadquarterDialog.vue?vue&type=script&lang=js"

import "./HeadquarterDialog.vue?vue&type=style&index=0&id=46c6692e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c6692e"]])

export default __exports__